import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  bookCar,
  cleanBookingData,
  clearBookCarData,
  stripeSessionGet,
} from "../../redux/Slice/bookingSlice";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import dayjs from "dayjs";
import SuccessModal from "../RentYourCar/PaymentSuccessModal";
import { getUserDetail } from "../../redux/Slice/authSlice";
import noDataImg from "../../assets/no-data-found.png";
import ClipLoader from "react-spinners/ClipLoader";
import axios from "axios";
import Swal from "sweetalert2";
const VefifyPayment = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const baseURL = useSelector((state) => state?.config?.baseURL);
  const bookingInfo = useSelector((state) => state?.booking?.bookingInfo);
  const personalDetailsData = useSelector(
    (state) => state?.booking?.personalDetailsData
  );
  const bookCarData = useSelector((state) => state?.booking?.bookCarData);
  const document = useSelector((state) => state?.booking?.documentsData);
  const withDriver = useSelector((state) => state?.booking?.withDriver);
  const rent = useSelector((state) => state?.booking?.rent);
  const bookingAmount = useSelector((state) => state?.booking?.bookingAmount);

  // const [differenceInDays, setDifferenceInDays] = useState(null);
  const userDetail = useSelector((state) => state?.auth?.userDetail);
  const { loginId } = useSelector((state) => state?.auth);

  const carId = useSelector((state) => state?.booking?.carId);
  const [base64Data, setBase64Data] = useState({});
  const [isPaid, setIsPaid] = useState(false);
  const [noData, setNoData] = useState(false);
  const bookCarStatus = useSelector((state) => state?.booking?.bookCarStatus);
  const bookingDays = useSelector((state) => state?.booking?.bookingDays);

  const { reference } = useParams(); // get the reference from URL params
  const location = useLocation();
  const response = location.state?.response;

  function calculateDifference(start, end) {
    const differenceInMilliseconds = Math.abs(end - start);
    return Math.ceil(differenceInMilliseconds / (1000 * 60 * 60 * 24));
  }

  useEffect(() => {
    setBase64Data({
      idFront: base64StringToSyntheticFile(document?.idFront),
      licenceFront: base64StringToSyntheticFile(document?.licence),
    });
  }, [document]);
  // useEffect(()=>{
  //  async function verifyHandler(){
  //       let verifyResponse= await axios.get(`https://api.lenco.co/access/v2/collections/status/${reference}`,        {
  //           headers: {
  //             'Authorization': `Bearer ${process.env.REACT_APP_LENCO_SECRET_KEY}`, // Authorization header
  //           },
  //         })
  //         console.log(verifyResponse,"verifyResponse ")
  //         if(verifyResponse?.data?.status && verifyResponse?.data.data.status==="successful")
  //         {
  //           carBookingHandler();
  //         }
  //   }
  //   verifyHandler();
  // },[reference])
  
  useEffect(() => {
    async function verifyHandler() {
      const interval = setInterval(async () => {
        try {
          const verifyResponse = await axios.get(
            `https://api.lenco.co/access/v2/collections/status/${reference}`,
            {
              headers: {
                'Authorization': `Bearer ${process.env.REACT_APP_LENCO_SECRET_KEY}`, // Authorization header
              },
            }
          );
          console.log(verifyResponse, "verifyResponse");
  
          if (verifyResponse?.data?.status && verifyResponse?.data.data.status !== "pending") {
            clearInterval(interval); // Stop the interval if status is not "pending"
            if (verifyResponse?.data.data.status === "successful") {
              carBookingHandler(); // Call your function if the status is "successful"
            } else {
              // Handle other statuses (if needed)
              console.log("Payment not successful, status:", verifyResponse?.data.data.status);
            }
          }
        } catch (error) {
          console.error("Error verifying status:", error);
          clearInterval(interval); // Stop the interval on error
        }
      }, 3000); // 3 seconds interval
  
      // Cleanup the interval if the component unmounts or reference changes
      return () => clearInterval(interval);
    }
    carBookingHandler();
    verifyHandler();
  }, [reference]);
  

//   useEffect(() => {
//     // const daysDifference = calculateDifference(
//     //   dayjs(bookingInfo?.pickUp),
//     //   dayjs(bookingInfo?.dropOff)
//     // );
//     // setDifferenceInDays(daysDifference);

//     async function bookingCreateHandler() {
//       console.log("func call");
//       console.log(base64Data);
//       if (JSON.stringify(base64Data).length >= 5) {
//         console.log("base64", base64Data);
//         const data = await dispatch(getUserDetail(loginId));
//         console.log("data", data);
//         if (data?.payload?.data?.stripeSessionId) {
//           const stripeSession = await dispatch(
//             stripeSessionGet(data?.payload?.data?.stripeSessionId)
//           );
//           console.log(
//             "data?.payload?.data?.stripeSessionId",
//             data?.payload?.data?.stripeSessionId
//           );
//           if (stripeSession?.payload?.data?.data?.payment_status === "paid") {
//             setIsPaid(true);
//             console.log(
//               "stripeSession?.payload?.data?.data?.payment_status",
//               stripeSession?.payload?.data?.data?.payment_status
//             );
//             carBookingHandler();
//           }
//         } else {
//           setNoData(true);
//         }
//       }
//     }
//     // DPO  token verify code 
    
//     // const result = await verifyToken();
//     bookingCreateHandler();
//   }, [base64Data]);
//   useEffect(() => {
//     return () => {
//       console.log("clear book car data & booking data");
//       dispatch(clearBookCarData());
//     };
//   }, []);
  // useEffect(() => {

  // }, [differenceInDays])
  // useEffect(() => {
  //   const daysDifference = calculateDifference(
  //     dayjs(bookingInfo?.pickUp),
  //     dayjs(bookingInfo?.dropOff)
  //   );
  //   setDifferenceInDays(daysDifference);

  //   return () => {
  //     dispatch(clearBookCarData())
  //   }
  // }, []);

//   const notify = () => toast(`${bookCarData?.data?.message}`);
//   useEffect(() => {
//     if (bookCarStatus === "success" && bookCarData.status === 200) {
//       dispatch(cleanBookingData());
//       notify();
//       setTimeout(() => {
//         navigate("/mybooking");
//       }, 4000);
//       dispatch(getUserDetail(userDetail?.data?._id));
//     }
//     if (bookCarStatus === "false" && bookCarData.status === 200) {
//       notify();
//     }
//   }, [bookCarStatus, bookCarData]);

  function base64StringToSyntheticFile(
    base64String,
    fileName = "image.png",
    fileType = "image/png"
  ) {
    if (base64String) {
      if (base64String.includes("base64")) {
        // Split the base64 string by comma to separate metadata from data
        const parts = base64String.split(",");
        // Extract the metadata part which contains the data type and base64 prefix
        const metadata = parts[0];
        // Split the metadata part by semicolon to separate data type and parameters
        const metadataParts = metadata.split(";");
        // Extract the data type which contains the MIME type and encoding
        const dataType = metadataParts[0];
        // Extract the file extension from the data type
        const extension = dataType.split("/")[1];

        fileType = dataType;
        fileName = `image.${extension}`;
        // Check if the base64 string contains a data URI prefix
        let str = base64String.substr(base64String.indexOf(",") + 1);
        // Log the base64 string before decoding

        // Convert base64 string to Blob
        const byteCharacters = atob(str);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: fileType });

        // Create synthetic file object
        const syntheticFile = new File([blob], fileName, {
          type: fileType,
        });

        return syntheticFile;
      } else {
        return base64String;
      }
    }
  }

  const carBookingHandler = () => {
    // window.open(`https://nodeapp.shrinkcom.com/kwacharides-backend/pay/displayGateWay/${totalAmount}`,'_blank')
    const currentDate = dayjs(); // Get current time from system
    let finalPickUpDate = bookingInfo?.pickUp;
    let pickUpDate = dayjs(bookingInfo?.pickUp);
    // Check if pickUpDate is today
    if (pickUpDate.isSame(currentDate, "day")) {
      // Check if pickUpDate is in the past
      if (
        pickUpDate.isBefore(currentDate, "minute") ||
        (pickUpDate.isSame(currentDate, "minute") &&
          pickUpDate.isBefore(currentDate, "second"))
      ) {
        // Update pickUpDate to current time
        let currentDateTime = new Date();
        const formattedDate = currentDateTime.toISOString();
        finalPickUpDate = formattedDate;
      }
    }

    const daysDifference = calculateDifference(
      dayjs(finalPickUpDate),
      dayjs(bookingInfo?.dropOff)
    );
    const payload = {
      userId: userDetail?.data?._id,
      carId: carId,
      pickUpDateandTime: dayjs(bookingInfo?.pickUp).format(
        "YYYY/MM/DD HH:mm:ss"
      ),
      returnDateandTime: dayjs(bookingInfo?.dropOff).format(
        "YYYY/MM/DD HH:mm:ss"
      ),
      noOfBookingDays: bookingDays,
      amount: rent?.carRent,
      totalAmount: bookingAmount,
      booking_for_someone_else: bookingInfo?.userToggle || false,
    };

    if (bookingInfo?.userToggle) {
      payload.name = personalDetailsData?.name.trim();
      payload.email = personalDetailsData?.emailId.trim();
      payload.phone = personalDetailsData?.phoneNumber.trim();
      payload.country_code ="+"+personalDetailsData?.countryCode.trim();
      payload.address = personalDetailsData?.address;
      payload.user_identity_front = document.idFront;
      payload.user_identity_back = document.licence;
    }
    payload.paymentStatus = "Completed";
    // const formData = new FormData();
    // formData.append("userId", userDetail?.data?._id);
    // formData.append("carId", carId);
    // formData.append("pickUpDateandTime", finalPickUpDate); // update time if pickupt time is less then current
    // // formData.append("pickUpDateandTime", bookingInfo?.pickUp);
    // formData.append("returnDateandTime", bookingInfo?.dropOff);
    // formData.append("name", personalDetailsData?.name);
    // formData.append("email", personalDetailsData?.emailId);
    // formData.append("phone", personalDetailsData?.phoneNumber);
    // // formData.append("UserPhoneNumber", personalDetailsData?.phoneNumber);
    // formData.append("country_code", personalDetailsData?.countryCode);
    // formData.append("address", personalDetailsData?.address);
    // formData.append("bookWithDriver", withDriver);
    // formData.append("driverRent", rent?.driverRent);
    // formData.append("paymentStatus", "Completed");
    // // formData.append("noOfBookingDays", bookingDays);
    // formData.append("noOfBookingDays", daysDifference); // after date time changes
    // formData.append("amount", rent?.carRent);
    // formData.append("totalAmount", bookingAmount);
    // formData.append(
    //   "identityFront",
    //   base64Data.idFront ? base64Data.idFront : document.idFront
    // );
    // formData.append(
    //   "drivingLicenseFront",
    //   base64Data.licenceFront ? base64Data.licenceFront : document.licence
    // );
    if(payload)
    {
      dispatch(bookCar(payload)).then((resp) => {
        if (resp?.payload?.data?.success) {
          toast.success(resp?.payload?.data?.message);

          Swal.fire({
            title: "Booking Details",
            html: `
            <div class="container">
              <div class="row mb-2">
                <div class="col-5 text-start"><strong>User:</strong></div>
                <div class="col-7 text-start">${resp?.payload?.data?.data?.user?.name}</div>
              </div>
              <div class="row mb-2">
                <div class="col-5 text-start"><strong>Phone:</strong></div>
                <div class="col-7 text-start">${resp?.payload?.data?.data?.user?.phoneNumber}</div>
              </div>
              <div class="row mb-2">
                <div class="col-5 text-start"><strong>Pick-Up Date and Time:</strong></div>
                <div class="col-7 text-start">${resp?.payload?.data?.data?.booking?.pickUpDateandTime}</div>
              </div>
              <div class="row mb-2">
                <div class="col-5 text-start"><strong>Return Date and Time:</strong></div>
                <div class="col-7 text-start">${resp?.payload?.data?.data?.booking?.returnDateandTime}</div>
              </div>
              <div class="row mb-2">
                <div class="col-5 text-start"><strong>Payment Status:</strong></div>
                <div class="col-7 text-start">${resp?.payload?.data?.data?.booking?.paymentStatus}</div>
              </div>
            </div>
          `,
            icon: "success",
            confirmButtonText: "OK",
            willClose: () => {
              dispatch(cleanBookingData());
              navigate("/mybooking");
            },
          });
          // setTimeout(() => {
          //   navigate("/mybooking");
          // }, 1500);
        } else {
          toast.error(resp?.payload?.data?.message);
        }
        let msg = resp?.payload?.response?.data?.errors[0];
        if (msg) {
          toast.error(msg?.msg);
        }
      });
    }
    // if (formData) {
    //   dispatch(bookCar(formData));
    // }
  };

  return (
    <>
      {noData && !isPaid ? (
        <div className="container-fluid">
          <div className="row justify-content-center mt-5">
            <img
              className="col-lg-4 text-center  w-160 "
              src={noDataImg}
              alt="no data found"
            />
            <h4 className="text-center mt-5 accentColor">
              "No Data Found...."
            </h4>
          </div>
        </div>
      ) : (
        <>
          {isPaid ? (
            <div className="container-fluid">
              <SuccessModal />
            </div>
          ) : (
            <div className="container-fluid">
              <div className="row justify-content-center mt-5">
                {/* <img
                  className="col-lg-4 text-center  w-160 "
                  src={noDataImg}
                  alt="no data found"
                />
                <h4 className="text-center mt-5 accentColor">
                  "No Data Found...."
                </h4> */}
                <ClipLoader
                  color="#008080"
                  loading={!isPaid ? true : false}
                  // cssOverride={{ height: "30px" }}
                  size={80}
                  aria-label="Loading Spinner"
                  data-testid="loader"
                />
              </div>
            </div>
          )}
        </>
      )}
    </>
  );
};

export default VefifyPayment;
